import { createAnimation, useIonRouter } from '@ionic/react';
import { useEffect, useRef } from 'react';
import { createSwipeBackGesture } from '../components/ComponentsGestures/SwipeBackGesture/customSwipeBackGesture';

// No-op animation that completes instantly - used after swipe gesture
// since the visual transition is already complete
const noAnimation = () => createAnimation().duration(0);

export const useCustomSwipeBack = (elementRef: React.RefObject<HTMLIonRouterOutletElement>) => {
    const router = useIonRouter();
    const gestureRef = useRef<any>(null);

    useEffect(() => {
        const el = elementRef.current;
        if (el) {
            const gesture = createSwipeBackGesture(
                el,
                () => router.canGoBack(),
                () => {
                    // Animation start is handled in createSwipeBackGesture
                },
                (step: number) => {
                    // Animation progress is handled in createSwipeBackGesture
                },
                (shouldComplete: boolean, step: number, duration: number) => {
                    if (shouldComplete) {
                        // Use no-animation since the gesture already completed the visual transition
                        router.goBack(noAnimation);
                    }
                }
            );

            gesture.enable(true);
            gestureRef.current = gesture;
        }

        return () => {
            if (gestureRef.current) {
                gestureRef.current.destroy();
            }
        };
    }, [router]);
};